import { eraseCookie, readCookie } from './cookies'
import { COOKIES_TRACKING_CONSENT_COOKIE_NAME, IS_WEB, IS_DEV } from '../config'

const domain = !IS_DEV && '.snips.ai'

// no longer loading GA directly, instead using Google Tag Manager
// id is used to disable tracking when the user opts-out
const GOOGLE_ANALYTICS_ID = 'UA-28086362-1'

function unblock (...args) {
  IS_WEB && window.yett && window.yett.unblock(...args)
}

export const analyticsMap = {
  google: {
    enable () {
      unblock(
        'https://www.googletagmanager.com',
        'https://www.google-analytics.com'
      )
    },
    cleanup () {
      eraseCookie('_ga', domain)
      eraseCookie('_gat_' + GOOGLE_ANALYTICS_ID, domain)
      eraseCookie('_gid', domain)
    },
    disable () {
      window['ga-disable-' + GOOGLE_ANALYTICS_ID] = true
    }
  },
  mixpanel: {
    enable () {
      unblock('https://cdn.mxpnl.com', 'https://api.mixpanel.com')
    },
    disable () {
      window.mixpanel &&
        window.mixpanel.opt_out_tracking &&
        window.mixpanel.opt_out_tracking()
    }
  },
  hubspot: {
    enable () {
      unblock(
        'https://js.hs-scripts.com',
        'https://js.hs-analytics.com',
        'https://track.hubspot.com'
      )
    },
    disable () {
      window._hsq &&
        window._hsq.push &&
        window._hsq.push(['revokeCookieConsent'])
    },
    cleanup () {
      eraseCookie('_hstc', domain)
      eraseCookie('_hssrc', domain)
      eraseCookie('hubspotuk', domain)
    }
  },
  googleAds: {
    enable () {
      unblock(
        'https://www.googletagmanager.com',
        'https://www.googleadservices.com'
      )
    }
  },
  bingAds: {
    enable () {
      unblock(['https://www.googletagmanager.com', 'https://bat.bing.com'])
    }
  },
  twitterAds: {
    enable () {
      unblock(
        'https://www.googletagmanager.com',
        'https://static.ads-twitter.com',
        'https://analytics.twitter.com'
      )
    }
  },
  linkedinAds: {
    enable () {
      unblock(
        'https://www.googletagmanager.com',
        'https://snap.licdn.com',
        'https://sjs.bizographics.com'
      )
    }
  }
}

const DEFAULT_ANALYTICS_COOKIE = {
  globallyEnabled: false,
  services: ['google']
}

export function getAnalyticsStatus () {
  const storedCookie = readCookie(COOKIES_TRACKING_CONSENT_COOKIE_NAME)
  if (storedCookie) {
    const parsedCookie = JSON.parse(storedCookie)
    return {
      globallyEnabled:
        parsedCookie.analytics || DEFAULT_ANALYTICS_COOKIE.globallyEnabled,
      services: !parsedCookie
        ? DEFAULT_ANALYTICS_COOKIE.services
        : parsedCookie.services || []
    }
  } else {
    return {
      ...DEFAULT_ANALYTICS_COOKIE
    }
  }
}

export function initialAnalyticsSetup () {
  const status = getAnalyticsStatus()
  if (status.globallyEnabled) {
    window.yett && window.yett.unblock()
  } else {
    status.services.forEach(service => {
      analyticsMap[service].enable()
    })
  }
}
initialAnalyticsSetup()

export function updateAnalytics (previousStatus, status) {
  if (status.globallyEnabled === true) {
    window.yett && window.yett.unblock()
    return
  }

  let needReload = false
  const previouslyEnabledServices = new Set(previousStatus.services)
  const enabledServices = new Set(status.services)

  // Services that get enabled
  status.services.forEach(service => {
    if (!previouslyEnabledServices.has(service)) {
      analyticsMap[service].enable()
    }
  })

  // Services that need to be disabled
  previousStatus.services.forEach(service => {
    if (!enabledServices.has(service)) {
      if (analyticsMap[service].cleanup) {
        analyticsMap[service].cleanup()
      }
      if (analyticsMap[service].disable) {
        analyticsMap[service].disable()
      } else {
        needReload = true
      }
    }
  })

  if (needReload) {
    window.location.reload()
  }
}
